// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3XXu-","search":"Settings_search__2CoOX","filter":"Settings_filter__2znpe"};